/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PressReleaseEditorMaster,
    PressReleaseEditorMasterFromJSON,
    PressReleaseEditorMasterFromJSONTyped,
    PressReleaseEditorMasterToJSON,
} from './PressReleaseEditorMaster';

/**
 * GET /press_release/editor
 * @export
 * @interface GetPressReleaseEditorMasterResponse
 */
export interface GetPressReleaseEditorMasterResponse {
    /**
     * 
     * @type {number}
     * @memberof GetPressReleaseEditorMasterResponse
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof GetPressReleaseEditorMasterResponse
     */
    message: string;
    /**
     * 
     * @type {PressReleaseEditorMaster}
     * @memberof GetPressReleaseEditorMasterResponse
     */
    data: PressReleaseEditorMaster;
}

export function GetPressReleaseEditorMasterResponseFromJSON(json: any): GetPressReleaseEditorMasterResponse {
    return GetPressReleaseEditorMasterResponseFromJSONTyped(json, false);
}

export function GetPressReleaseEditorMasterResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPressReleaseEditorMasterResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': PressReleaseEditorMasterFromJSON(json['data']),
    };
}

export function GetPressReleaseEditorMasterResponseToJSON(value?: GetPressReleaseEditorMasterResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': PressReleaseEditorMasterToJSON(value.data),
    };
}

